import { render } from "./ConfirmationDamageList.vue?vue&type=template&id=68d93de1&scoped=true&ts=true"
import script from "./ConfirmationDamageList.vue?vue&type=script&lang=ts"
export * from "./ConfirmationDamageList.vue?vue&type=script&lang=ts"

import "./ConfirmationDamageList.vue?vue&type=style&index=0&id=68d93de1&lang=scss&scoped=true"

import exportComponent from "/builds/knx-core/freightbox/freightbox-monorepo-vue/services/eleos-driver-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68d93de1"]])

export default __exports__